import errorCodes from '@/libs/constant/errorCodes'
import pageRoute from '@/libs/constant/pageRoutes'

export default {
    methods: {
        /**
         * role error handler of team and organisation
         * @param {*} errorObject error object containing code
         * @param {*} isUpdateTeamRoles teams or organisation
         */
        rolesErrorHandler (errorObject, isUpdateTeamRoles) {
            // if the error message is invoked
            if (errorObject && errorObject.code && errorObject.code === errorCodes.PERMISSION_REVOKED.code) {
                // change route to overview page
                this.$router.push({name: pageRoute.organisationOverview, params: {id: this.$route.params.id}}).catch(() => {})
                // refetch the roles and permissions
                if (isUpdateTeamRoles) this.$store.dispatch('setUpdateTeamRoles', true)
                else this.$store.dispatch('setUpdateOrganisationRoles', true)
            }
        }
    }
}